import {
  SiVisa,
  SiMastercard,
  SiAmericanexpress,
  SiDiscover,
  SiDinersclub,
} from "react-icons/si";

const PaymentIcons = ({ brand, className }) => {
  const icons = {
    visa: <SiVisa className={className} />,
    mastercard: <SiMastercard className={className} />,
    amex: <SiAmericanexpress className={className} />,
    discover: <SiDiscover className={className} />,
    diners: <SiDinersclub className={className} />,
    unionpay: (
      <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <text
          x="50%"
          y="55%"
          textAnchor="middle"
          fontSize="6"
          fill="currentColor"
          fontFamily="sans-serif"
        >
          U
        </text>
      </svg>
    ),
    default: (
      <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <rect x="2" y="5" width="20" height="14" rx="2" strokeWidth="2" />
        <path d="M2 10H22" strokeWidth="2" />
      </svg>
    ),
  };

  return icons[brand?.toLowerCase()] || icons.default;
};

export default PaymentIcons;
